/**
 * The default distance, in pixels, between the mouse position and a snappable
 * measurement feature.
 */
export const MEASUREMENT_SNAP_DISTANCE = 16;

/**
 * The default length, in pixels, for the measurement line cap.
 */
export const MEASUREMENT_LINE_CAP_LENGTH = 10;
